define.alias("ember-composable-helpers/helpers/from-entries", "calendar/helpers/from-entries");